export default __webpack_public_path__ + "6dd2b4508c77cfd54aec2ed52f02c3be.webp";